import type { FaireProductEntity } from "../../entity_types/product";

export const p_b9ard9quv4: FaireProductEntity = {
  token: "p_b9ard9quv4",
  type: "product",
  name: "Minnesota-Opoly (state) Board Game",
  brandName: "Outset Games and Cobble Hill Puzzles",
  imageUrl:
    "https://cdn.faire.com/fastly/1758365a7b07d9a8f0ffe9ea58e6f1132996809bf75c986aaeb9da69621822fb.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a30af0050f462f64d0a30332fb05de3acd37075b220f321683119d8fa252ba55.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
